var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashbordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_347_5842",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_347_5842",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAADnElEQVR4nO2cz2oTURjFz6fYFkT7BtKq1YW4EUtFcKmg2Bdx4TN0LSIU+gIufAFTiyCCVhRFcaUoUv+gLyCCYAvJcTGthGaSezOZSb57Pb/t3Lnz/XIIzdCZAwghhBDVsGFPIDkPYBnAEoB5AFM1zbID4CuAlwBaZvatpn1LSd6D5BLJhyQ7bJ4OyQ2Si/LoFZghuTYmgf20Sa6SnJZHITFL8vkEBPazSXL2f/Do+zeE5AyAxwAuVv0gauYZgMtmtj3MSal5HBhw4m34kQCASwBuVTgvKY/SbwjJCwBe9Ds+QToAlszsTcziFD36fUNW4E8CKOZdGWL9ChLz6BmWxe/zz2XH9rENoLW7tg4WAFxH+H6gA2DezL4PWpSLB0jejPi18IHkyZoEuq+9QPJjxPVvROyVhQdI3gts8qcJia7rnyK5HZjhbq4eZX9Djgeu1TKzrXrG7sXMPgF4EFh2ImKrJD3KAjkS2ORD7FAj8D5wPOYmMUmPQfch/ehUOGdY2oHjdfxyculRJRDRIArEGQrEGQrEGQrEGQrEGQrEGQrEGQrEGQrEGQrEGQrEGQrEGQrEGQrEGVUCGUeIBwPHWcM1XHqUDfUrsMmZ6HGqE7rGz4g9kvQoC+RLYJPrJBeiRxoSkqdRPEYziNCMMWtcepQF8iqwyRSAFslTkbNFsytxH8ChwNKXEdsl6VH2oNwciuRC/7feQfFUxTsAv2MGHcBhAGcBXEPcA2ZzZvZj0KJUPfo927sB4OqIwzXFupktxyxM0aNfIIsovk7efhZ3ACya2duYxSl6lA5qZq8BrDU9VQVWY8MA0vQY9MLONIBHKN5n8MBTAFfMbGeYk3LxAPDvVbDNwPOp4+AJyaNVPwFm4rEnM83ihcX2BATaJO+QHPmV5Vw8uoXOk1wfk1CbZIvkudoEEvGoUhxwDMUd6BKKp7dnht2jD38AbKG4oVsP3WeMSi4eQgghhBBCCDEqapRL1YOpN7Hl4sEcmthy8WBCTWy5eKhRbvyoUQ4JeahRbjKoUc4ZapQbgGuPbJrYcvFItoktFw81yjWEGuV6SdJDjXLNoka51FEgzlAgzlAgzlAgzlAgzlAgzlAgzlAgzlAgzlAgzlAgzlAgzlAgzlAgzlCjXLOoUa6LJD3UKNcQVT3UKOfMQ41yzjzUKDc51CjnCDXKOUONckjcA0A+TWzMxGNPJosmtlw8uoVcN7Hl4qFGucQ9hBBCiD3+AhhRR49yS8rAAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashbordIcon);
export default __webpack_public_path__ + "static/media/dashbordIcon.e69b8d0e85c681e9acced78f54f1370b.svg";
export { ForwardRef as ReactComponent };